import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Footer from "../../components/Footer.js";
import HeaderTransprent from "../../components/HeaderTransprent.js";
import Heading from "../../components/ui/Heading.js";
import TagHeading from "../../components/ui/TagHeading.js";
import Button from "../../components/ui/Button.js";
import ButtonBorder from "../../components/ui/ButtonBorder.js";
import ButtonReadmore from "../../components/ui/ButtonReadmore.js";
import Methodology from "../../components/ui/Methodology.js";
import Different from "../../components/ui/Different.js";
import ContactForm from "../../components/ui/ContactForm.js";
import JsonData from "../Json/leadership.json";
import { GoCheckCircle } from "react-icons/go";
// import { MdOutlineArrowForwardIos, MdOutlineArrowBackIos } from "react-icons/md";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";

const Home = () => {

  const formRef = useRef(null);
  const history = useHistory();

  // const handleClick = (field) => {
  //   history.push(field ? `/${field}` : "/");
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleScrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const [activeTab, setActiveTab] = useState(JsonData.philosophyTabs[0].key);

  const activeContent = JsonData.philosophyTabs.find(
    (tab) => tab.key === activeTab
  );

  return (
    <>
      <div className="">

        <HeaderTransprent />
        <section className="bg-cover bg-no-repeat bg-center w-full py-20 h-auto bgpagecolor" style={{ backgroundImage: `url('/img/assets/home/executive-search.webp')`, }}>
          <div className="w-full h-full">
            <div className="flex md:flex-row flex-col gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12 md:h-[40rem] h-[35rem]">
              <div className="flex flex-col justify-center space-y-8 md:max-w-4xl my-auto pt-10 md:pt-16 md:pb-12 w-full h-full md:text-left text-center">
                <Heading className="textwhite" text="Executive Search Solutions: Leaders for a Better Tomorrow" />
                <div data-aos="fade-right" className="font-medium text-xl md:text-2xl textwhite">
                  <p className="pb-2">Executive search crafted through leadership science, strengths, and culture alignment.</p>
                </div>
                <div data-aos="fade-right" className="font-medium text-base md:text-lg textwhite">
                  <p className="pb-2">It’s about choosing the person your <span className="font-semibold">tomorrow can rely on.</span></p>
                </div>
                <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-4 md:space-y-0">
                  <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-64 w-full">
                    <Button text="Book a Consultation" onClick={() => history.push("/contact-us")} />
                  </div>
                  <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-64 w-full">
                    <ButtonBorder text="View All Services" onClick={() => history.push("/services")} />
                  </div>
                </div>
              </div>

              {/* <div className="flex justify-center items-center w-full">
                <img data-aos="fade-left" src="/img/assets/home/agrpartners.webp" alt="agrpartners" className="z-0" />
              </div> */}
            </div>
          </div>
        </section>

        {/* INTRODUCTION */}
        <section className="bg-white md:py-16 py-8">
          <div className="flex lg:flex-row flex-col-reverse items-center gap-10 mx-auto px-4 xl:px-0 py-10 w-full 2xl:w-[80%] xl:w-11/12">
            <div className="items-start gap-8 grid lg:grid-cols-2 mx-auto">
              <div class="md:pr-10 pr-0">
                <img src="/img/assets/home/allenanddonald-intro.webp" alt="why-choose-us" class="" />
              </div>

              <div className="">
                <TagHeading className="textactive" text="INTRODUCTION" />
                <Heading className="textblack" text="Leadership defines destiny" />
                <p className="md:text-lg text-base textblack mt-5">In a world where strategy shifts overnight, one constant remains: great leadership drives performance, inspires teams, and transforms culture.</p>
                <p className="md:text-lg text-base textblack mt-5">GregandAllen Executive Search helps organizations discover leaders who don’t just fill roles — they make you leap.</p>

                <div class="gap-4 md:gap-6 grid grid-cols-1 mt-8">
                  <p className="text-2xl font-semibold textactive">Key Value Points</p>
                  <div class="flex items-start space-x-3">
                    <div className="w-8 h-8">
                      <GoCheckCircle className="textactive mt-1 w-8 h-8" />
                    </div>
                    <div>
                      <p class="text-lg textblack"><span className="font-semibold">Human Insight + Data-Driven Science →</span> We evaluate purpose, values, and capability.</p>
                    </div>
                  </div>
                  <div class="flex items-start space-x-3">
                    <div className="w-8 h-8">
                      <GoCheckCircle className="textactive mt-1 w-8 h-8" />
                    </div>
                    <div>
                      <p class="text-lg textblack"><span className="font-semibold">Cultural & Strategic Fit →</span> We look beyond résumés to your organization’s true needs.</p>
                    </div>
                  </div>
                  <div class="flex items-start space-x-3">
                    <div className="w-8 h-8">
                      <GoCheckCircle className="textactive mt-1 w-8 h-8" />
                    </div>
                    <div>
                      <p class="text-lg textblack"><span className="font-semibold">Future-Ready Leadership →</span> The right leader unlocks growth your strategy alone cannot.</p>
                    </div>
                  </div>
                  <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-64 w-full">
                    <Button text="Read more about us" onClick={() => history.push("/about-us")} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services */}
        <section className="bg-[#9B26350F] textwhite py-20">
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
              <div>
                <TagHeading className="textactive" text="Services" />
                <Heading className="textblack" text="Explore Our Executive Search Solutions" />
              </div>
              <div className="flex flex-col justify-center lg:items-start">
                <p className="md:text-lg text-base textblack mb-6">Leadership experts who combine insight, science, and business judgment to discover leaders who shape the future.</p>
                <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-64 w-full">
                  <Button text="View All Services" onClick={() => history.push("/services")} />
                </div>
              </div>
            </div>

            {/* Services Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {JsonData.servicesData.map((service) => (
                <div key={service.id} className="group service-card bg-white rounded-2xl p-8 border transition hover:shadow-lg">
                  <div className="mb-6 bg-[#9B26350F] w-24 h-24 rounded-full flex items-center justify-center">
                    <img src={service.icon} alt={service.title} className="w-16 h-16" />
                  </div>
                  <h2 className="text-xl textblack group-hover:text-[#9B2635] mb-4">{service.title}</h2>
                  <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
                  <ButtonReadmore text="Read More" onClick={() => history.push("/services")} />
                </div>
              ))}
            </div>
          </div>
        </section>

        <Methodology />

        {/* Why GregandAllen */}
        <section className="bg-cover py-16 bg-no-repeat bg-center w-full h-auto bgpagecolor" style={{ backgroundImage: "url('/img/assets/home/why-allen-and-donald.webp')", }}>
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12">
            <div className="max-w-2xl textwhite">
              <TagHeading className="textwhite" text="Why GregandAllen" />
              <Heading className="textwhite" text="Why Organizations Choose GregandAllen" />
              <p className="md:text-lg text-base textwhite mt-5 mb-10">Because Leadership Decisions Deserve Depth, Science, And Trust.</p>
              <div className="space-y-6">
                {JsonData.organizationsChoose.map((item, index) => (
                  <div key={index} className="flex items-center gap-5 border-b last:border-none border-white/30 pb-6">
                    <div className="w-20 h-20 sm:w-20 sm:h-20 flex-shrink-0 flex items-center justify-center border border-white/40 rounded-lg">
                      <img src={item.icon} alt={item.title} className="w-16 h-16 sm:w-16 sm:h-16 object-contain" />
                    </div>
                    <div>
                      <h1 className="md:text-xl text-lg font-semibold mb-1">{item.title}</h1>
                      <p className="textwhite/80 text-sm">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </section>

        {/* Our Philosophy */}
        <section className="bg-[#fbf4f2] py-20">
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
              <div className="space-y-4">
                <TagHeading className="textactive" text="Our Methodology" />
                <Heading className="textblack" text="Our Philosophy" />
                <p className="md:text-lg text-base textblack">Leadership Is A Responsibility. Selecting Leaders Is A Craft. </p>
                <div className="flex justify-start pt-10">
                  <img src={activeContent.icon} alt={activeContent.label} className="w-full max-w-lg transition-all duration-300" />
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="space-y-6">
                <div className="space-y-4">
                  <p className="textblack mb-3 leading-relaxed">At Our philosophy integrates the science of talent, the power of strengths, and the four timeless pillars of leadership success — Having VIEW: <span className="font-semibold">Vision, Impact, Execution, and Wisdom.</span></p>
                  <p className="textblack leading-relaxed">These four pillars anchor how we evaluate, understand, and select leaders who can transform organizations.</p>
                </div>

                {/* TABS */}
                <div className="border-b border-red-700/30 flex xl:gap-10 lg:gap-0 mb-8 w-full">
                  {JsonData.philosophyTabs.map((tab) => (
                    <button
                      key={tab.key}
                      onClick={() => setActiveTab(tab.key)}
                      className={`pb-3 text-lg font-semibold transition w-full
                  ${activeTab === tab.key
                          ? "textwhite bgcolor lg:px-6 px-2 py-3"
                          : "textblack lg:px-6 px-2 py-3"
                        }`}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>

                {/* TAB CONTENT */}
                <div>
                  <h2 className="textblack font-semibold md:text-xl text-lg mb-6">
                    {activeContent.content.heading}
                  </h2>

                  <p className="textblack mb-6">
                    {activeContent.content.description}
                  </p>

                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {activeContent.content.points?.map((point, index) => (
                      <li key={index} className="flex items-start gap-3 textblack">
                        <GoCheckCircle size={26} className="textactive shrink-0" />
                        <span className="font-semibold">{point}</span>
                      </li>
                    ))}
                  </ul>

                  {/* ✅ ONLY for Wisdom */}
                  {activeContent.content.heading2 && (
                    <p className="textblack my-4 font-medium">
                      {activeContent.content.heading2}
                    </p>
                  )}

                  {activeContent.content.points2 && (
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      {activeContent.content.points2.map((point, index) => (
                        <li key={index} className="flex items-start gap-3 textblack">
                          <GoCheckCircle size={26} className="textactive shrink-0" />
                          <span className="font-semibold">{point}</span>
                        </li>
                      ))}
                    </ul>
                  )}

                  <p className="textblack mt-6">
                    {activeContent.content.paragraph}
                  </p>
                </div>

                {/* <div>
                  <h2 className="textblack font-semibold md:text-xl text-lg mb-6">{activeContent.content.heading}</h2>
                  <p className="textblack mb-6">{activeContent.content.description}</p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {activeContent.content.points.map((point, index) => (
                      <li key={index} className="flex items-start gap-3 textblack">
                        <GoCheckCircle size={26} className="textactive" />
                        <span className="font-semibold">{point}</span>
                      </li>
                    ))}
                  </ul>
                  <p className="textblack my-2">{activeContent.content.heading2}</p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {activeContent.content.points2.map((point, index) => (
                      <li key={index} className="flex items-start gap-3 textblack">
                        <GoCheckCircle size={26} className="textactive" />
                        <span className="font-semibold">{point}</span>
                      </li>
                    ))}
                  </ul>
                  <p className="textblack mt-6">{activeContent.content.paragraph}</p>
                </div> */}

              </div>
            </div>
          </div>
        </section>

        <Different />

        {/* <section className="bg-white py-20">
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12 relative">
            <div className="text-center mb-16">
              <Heading className="textblack" text="Meet Our Experts" />
              <p className="max-w-3xl mx-auto md:text-lg text-base textblack mt-5">
                Leadership Experts Who Combine Insight, Science, And Business
                Judgement To Discover Leaders Who Shape The Future.
              </p>
            </div>
            <button className="experts-prev absolute left-0 top-1/2 -translate-y-1/2 z-10 md:w-12 md:h-12 w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition">
              <MdOutlineArrowBackIos size={28} />
            </button>
            <button className="experts-next absolute right-0 top-1/2 -translate-y-1/2 z-10 md:w-12 md:h-12 w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition">
              <MdOutlineArrowForwardIos size={28} />
            </button>
            <div className="lg:px-16 px-8">
              <Swiper
                modules={[Navigation]}
                navigation={{
                  prevEl: ".experts-prev",
                  nextEl: ".experts-next",
                }}
                spaceBetween={40}
                slidesPerView={1}
                breakpoints={{
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                }}
              >
                {JsonData.expertsData.map((expert) => (
                  <SwiperSlide key={expert.id}>
                    <div>
                      <div className="rounded-xl overflow-hidden mb-6">
                        <img src={expert.image} alt={expert.name} className="w-full h-64 object-cover" />
                      </div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-1">{expert.name}</h3>
                      <p className="text-xs uppercase tracking-wide text-gray-500 mb-4">{expert.role}</p>
                      <p className="textblack mb-4 line-clamp-3">{expert.description}</p>
                      <button className="text-red-700 font-semibold inline-flex items-center gap-2 hover:gap-3 transition-all">
                        Read More <span>→</span>
                      </button>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </section> */}

        <ContactForm />

        <Footer />
      </div>
    </>
  );
};


export default Home;
